import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VinHistoryService {
  baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getVinHistory(): Observable<string[]> {
    return this.http.get<string[]>(this.baseUrl + 'vinhistory').pipe(
      tap(() => console.log('vin history opgehaald')),
      catchError(this.handleError)
    );
  }

  private handleError(err) {
    let errorMessage: string;

    if (err.error instanceof ErrorEvent) {
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      errorMessage = `Backend returned code ${err.status}: ${err.body?.error || err.message}`;
    }

    console.error(err);
    return throwError(errorMessage);
  }
}